const FIND_ALL_SUBSCRIPTIONS = 'OVID/CUSTOMER/FIND_ALL_SUBSCRIPTIONS'
const FIND_ALL_SUBSCRIPTIONS_SUCCESS = 'OVID/CUSTOMER/FIND_ALL_SUBSCRIPTIONS_SUCCESS'
const FIND_ALL_SUBSCRIPTIONS_FAILED = 'OVID/CUSTOMER/FIND_ALL_SUBSCRIPTIONS_FAILED'

export const constants = {
  FIND_ALL_SUBSCRIPTIONS,
  FIND_ALL_SUBSCRIPTIONS_SUCCESS,
  FIND_ALL_SUBSCRIPTIONS_FAILED,
}
